// extracted by mini-css-extract-plugin
export default {"button":"NqIwEt","expand":"Mh2juo","suffixIcon":"hIORQG"};